import { render, staticRenderFns } from "./Ernaehrungsformen.vue?vue&type=template&id=38ac8b6f&"
import script from "./Ernaehrungsformen.vue?vue&type=script&lang=js&"
export * from "./Ernaehrungsformen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports